<template>
  <div class="order-basket">
    <div class="order-basket_top">
      <div class="order-basket_title">Корзина</div>
      <div class="order-basket_title">{{ getBasketPriceLocale }}</div>
    </div>
    <div class="order-basket_items">
      <BasketItem
        v-for="item in getBasketItems"
        :key="item.id"
        :item="item"/>
    </div>
    <div class="order-basket_link-wrapper">
      <a :href="getBasketUrl">Перейти в корзину</a>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import BasketItem from './BasketItem'
  import localPrice from '../../utils/localPrice'

  export default {
    name: 'Basket',
    components: {
      BasketItem
    },
    computed: {
      ...mapGetters('order', [
        'getBasketUrl',
        'getBasketPrice',
        'getBasketItems'
      ]),
      getBasketPriceLocale: function () {
        return localPrice(this.getBasketPrice)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Basket.vue